import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=2b81bbf0&scoped=true&"
import script from "./Warehouses.vue?vue&type=script&lang=ts&"
export * from "./Warehouses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81bbf0",
  null
  
)

export default component.exports